import React from 'react';

import {
  ErrorBoundaryImg,
  ErrorBoundaryText,
  ErrorBoundaryWrapperSmall,
} from './error-boundary.ui';

const SmallFallback: React.FC = () => {
  return (
    <ErrorBoundaryWrapperSmall>
      <ErrorBoundaryImg
        width="24px"
        height="24px"
      />
      <ErrorBoundaryText>Hmm, something seems to be missing</ErrorBoundaryText>
    </ErrorBoundaryWrapperSmall>
  );
};

export default SmallFallback;
